import type { paths } from "@/api-schema";

export const VEHICLE_VALUATION_COST_ADDITION_RESOURCE = "vehicle-valuation-cost-addition" as const;
export const VEHICLE_VALUATION_COST_ADDITION_API_PATH = `/v1/${VEHICLE_VALUATION_COST_ADDITION_RESOURCE}` as const;
export const VEHICLE_VALUATION_COST_ADDITION_SEARCH_OPERATION = "search" as const;
export const VEHICLE_VALUATION_COST_ADDITION_SEARCH_API_PATH =
  `${VEHICLE_VALUATION_COST_ADDITION_API_PATH}/${VEHICLE_VALUATION_COST_ADDITION_SEARCH_OPERATION}` as const;

export type VehicleValuationCostAdditionPutBody =
  paths[typeof VEHICLE_VALUATION_COST_ADDITION_API_PATH]["put"]["requestBody"]["content"]["application/json"];

export type VehicleValuationCostAdditionPutResponse =
  paths[typeof VEHICLE_VALUATION_COST_ADDITION_API_PATH]["put"]["responses"][200]["content"]["application/json"];

export type VehicleValuationCostAdditionSearchBody =
  paths[typeof VEHICLE_VALUATION_COST_ADDITION_SEARCH_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export type VehicleValuationCostAdditionSearchParameters =
  paths[typeof VEHICLE_VALUATION_COST_ADDITION_SEARCH_API_PATH]["post"]["parameters"]["query"];

export type VehicleValuationCostAddition =
  paths["/v1/vehicle-valuation-cost-addition/{uuid}"]["get"]["responses"][200]["content"]["application/json"];

export type VehicleValuationCostAdditionSearchResponse =
  paths[typeof VEHICLE_VALUATION_COST_ADDITION_SEARCH_API_PATH]["post"]["responses"][200]["content"]["application/json"];
